import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
  Box,
} from "@mui/material";
import Header from "../../components/Header";
import { Footer } from "../../components/Footer";
import { CallWithAuth } from "../../action/apiActions";
import { createShortNameFile, errorMessageCreate } from "../../util/custom";
import { showToast } from "../../util/toastHelper";
import { POST_SUPPORT } from "../../action/apiPath";
import rightArrow from "../../assets/img/arrow-right.svg";
import upload_icon from "../../assets/img/upload_icoon.svg";

export const ConnectSupport = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    issue: "",
    issueDetails: "",
    image: null,
  });

  const [uploadedImage, setUploadedImage] = useState(null);
  const [errors, setErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));

    if (files && files[0] && name === "image") {
      setUploadedImage(URL.createObjectURL(files[0]));
    }
  };

  async function validateImage(file) {
    const maxSizeMB = 25;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;
    const allowedExtensions = ["image/png", "image/jpeg", "image/jpg"];

    if (!allowedExtensions.includes(file.type)) {
      showToast("error", "Only JPG, JPEG, and PNG files are allowed.");
      return false;
    }

    if (file.size > maxSizeBytes) {
      showToast("error", `File size should not exceed ${maxSizeMB} MB.`);
      return false;
    }

    const isExecutable = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = (evt) => {
        if (evt.target.readyState === FileReader.DONE) {
          const uint = new Uint8Array(evt.target.result);
          const header = Array.from(uint).map(b => b.toString(16).padStart(2, '0')).join('');console.log(header);

          // 1. Check for Executables (MZ header)
          if (header.startsWith("4d5a")) return resolve(true);

          // 2. Verify it's actually a valid Image type
          const isPNG = header.startsWith("8950"); // .png
          const isJPEG = header.startsWith("ffd8");  // .jpg / .jpeg

          // If the extension says png/jpg but the bytes don't match, block it
          if (isPNG || isJPEG) {
            return resolve(false);
          }

          resolve(true);
        }
      };
      reader.readAsArrayBuffer(file.slice(0, 2));
    });
  
    if (isExecutable) {
      showToast("error", "File is an executable disguised as an image!");
      return false;
    }

    return true;
  }

  async function handleChangeUploadImageFile(e) {
    const file = e.target.files[0];
    if (file) {
      const isImage = await validateImage(file);
      if (!isImage) {
        setUploadedImage(null);
        setFormData((prev) => ({
          ...prev,
          image: null,
        }));
        return;
      };
      setUploadedImage(URL.createObjectURL(file));
      setFormData((prev) => ({
        ...prev,
        image: file,
      }));
    }
  }

  async function handleDropUploadImage(e) {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      const isImage = await validateImage(file);
      if (!isImage) {
        setUploadedImage(null);
        setFormData((prev) => ({
          ...prev,
          image: null,
        }));
        return;
      };
      setUploadedImage(URL.createObjectURL(file));
      setFormData((prev) => ({
        ...prev,
        image: file,
      }));
    }
    // e.preventDefault();
    // const file = e.dataTransfer.files[0];
    // if (file) {
    //   setUploadedImage(URL.createObjectURL(file));
    //   setFormData((prev) => ({
    //     ...prev,
    //     image: file,
    //   }));
    // }
  }

  function handleDragOverUploadImage(e) {
    e.preventDefault();
  }

  function handleDragLeaveUploadImage(e) {
    e.preventDefault();
  }

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!formData.phone.trim()) newErrors.phone = "Phone is required";
    if (formData.phone.trim() && isNaN(formData.phone.trim())) {
      newErrors.phone = "Phone number must be numeric";
    }
    if (formData.phone.trim() && parseInt(formData.phone.trim()) < 0) {
      newErrors.phone = "Phone number can not be negative";
    }
    if (formData.phone.trim() && (formData.phone.trim().length < 10 || formData.phone.trim().length > 15)) {
      newErrors.phone = "Phone number must be between 10 to 15 digits";
    }
    if (!formData.issue.trim()) newErrors.issue = "Issue is required";
    if (!formData.issueDetails.trim())
      newErrors.issueDetails = "Details are required";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    // console.log(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});
    setIsSubmit(true);

    const data = new FormData();

    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    data.append("subject", formData.issue);
    data.append("subjectDetails", formData.issueDetails);

    if (formData.image) {
      data.append("image", formData.image);
    }

    try {
      const response = await CallWithAuth("POST", POST_SUPPORT, data);
      let message = errorMessageCreate(response?.res?.data?.message);
      if (response?.res?.data?.statusCode === 201) {
        showToast("success", message);
        setFormData({
          name: "",
          email: "",
          phone: "",
          issue: "",
          issueDetails: "",
          image: null,
        });
        setUploadedImage(null);
      } else {
        showToast("error", message);
        setIsSubmit(false);
      }
    } catch (err) {}
    setIsSubmit(false);
  };

  return (
    <>
      <Header />
      <section class="from_our_desk" style={{ marginTop: "100px" }}>
        <h1 className="csm_page_title">Connect With Support</h1>{" "}
        <>
          <section className="mycustomclass patient_form_block">
            <div class="site_container">
              <div class="patient_form">
                <div className="row">
                  <div className="col-md-6">
                    <div className="field_block">
                      <label>Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="text_field"
                      />
                      {errors.name && <p className="error">{errors.name}</p>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="field_block">
                      <label>Email *</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="text_field"
                      />
                      {errors.email && <p className="error">{errors.email}</p>}
                    </div>                    
                  </div>
                  <div className="col-md-6">
                    <div className="field_block">
                      <label>Phone *</label>
                      <input
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="text_field"
                      />
                      {errors.phone && <p className="error">{errors.phone}</p>}
                    </div>                    
                  </div>
                  <div className="col-md-6">
                    <div className="field_block">
                      <label>Issue *</label>
                      <input
                        type="text"
                        name="issue"
                        value={formData.issue}
                        onChange={handleChange}
                        className="text_field"
                      />
                      {errors.issue && <p className="error">{errors.issue}</p>}
                    </div>                    
                  </div>
                </div>
                <div className="field_block">
                  <label>Issue Details *</label>
                  <textarea
                    name="issueDetails"
                    value={formData.issueDetails}
                    onChange={handleChange}
                    className="text_field"
                  />
                  {errors.issueDetails && (
                    <p className="error">{errors.issueDetails}</p>
                  )}
                </div>

                <div
                  className="field_block"
                  onDrop={(e) => handleDropUploadImage(e)}
                  onDragOver={handleDragOverUploadImage}
                  onDragLeave={handleDragLeaveUploadImage}
                >
                  <div className="upload_field">
                    <div className="title">
                      <label>Upload Image (Optional)</label>
                    </div>

                    <div className="upload_ui">
                      <label
                        className="upload_ui_label"
                        style={{ cursor: "pointer" }}
                      >
                        <input
                          type="file"
                          name="UploadImage"
                          accept=".png, .jpg, .jpeg" // Only allow image files
                          onChange={handleChangeUploadImageFile}
                          style={{ display: "none" }} // Hide input element
                        />
                        <div className="ui_inner">
                          <img src={upload_icon} alt="Upload" />
                          <h5>Upload</h5>
                          <p>
                            <span>Browse</span> to upload the file
                          </p>
                        </div>
                      </label>
                    </div>

                    {uploadedImage && uploadedImage !== "" && (
                      <div className="record_seesion_info">
                        <p className="sm_txt">
                          <strong>{createShortNameFile(uploadedImage)}</strong>
                        </p>
                        {/* <a
                            href={`${uploadedImage}`} // Full URL for file (e.g. S3)
                            target="_blank"
                            rel="noopener noreferrer"
                            className="edit"
                          >
                            <i className="fa-solid fa-eye"></i>
                          </a> */}
                      </div>
                    )}
                  </div>
                </div>

                <div className="field_block">
                  <div className="btn_row">
                    <button
                      // disabled={isFaceImageLoading || isSubmit}
                      onClick={handleSubmit}
                      disabled={isSubmit}
                    >
                      <span>Submit </span> <img src={rightArrow} alt="Arrow" />
                      {isSubmit && (
                        <>
                          {""}
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      </section>
      <Footer />
    </>
  );
};

export default ConnectSupport;
